import Vue from 'vue';
import Router from 'vue-router';

import Body from '../components/body';
import Auth from '../auth/auth';

/* Auth */
import login from '../auth/login';
import Register from '../auth/register';
import forgotPassword from '../auth/forgot-password';

/* Dashboards */
import Default from '../pages/dashboard/default';
import transactionHistory from '../pages/dashboard/transaction-history';
import beneficiaryManagement from '../pages/dashboard/beneficiary-management';

/* Transfers */
import interbankTransfer from '../pages/transfers/interbank-transfer';
import ownAccountTransfer from '../pages/transfers/own-account-transfer';
import localTransfer from '../pages/transfers/local-transfer';
import multipleTransfer from '../pages/transfers/multiple-transfer';

// auth settings
import changePin from '../pages/settings/change-pin';
import changeSecurityQuestion from '../pages/settings/change-security-question';
import changePassword from '../pages/settings/change-password';
import resetSecurityQuestion from '../pages/settings/reset-security-question';
import resetPin from '../pages/settings/reset-pin';
import createPin from '../pages/settings/create-pin';
import accountUpgrade from '../pages/settings/account-upgrade';
import limitUpgrade from '../pages/settings/limit-upgrade';


// Bills
import airtimePurchase from '../pages/bills/airtime-purchase';
import dataPurchase from '../pages/bills/data-purchase';
import electricityPayment from '../pages/bills/electricity-payment';
import cablePayment from '../pages/bills/cablePayment';

// standing order 
import manageStandingOrder from '../pages/standingOrder/manage-standing-orders';
import standingOrderTaj from '../pages/standingOrder/local';
import standingOrderOthers from '../pages/standingOrder/interbank';

// request management
import cardRequest from '../pages/requestManagement/card';
import chequeRequest from '../pages/requestManagement/cheque';
import tokenRequest from '../pages/requestManagement/token';
import stopCheque from '../pages/requestManagement/stop-cheque';
import cashWithdrawal from '../pages/requestManagement/cash-withdrawal';
import statementRequest from '../pages/requestManagement/statement-request';
import hotListCard from '../pages/requestManagement/hotlist-card';
import formA from '../pages/requestManagement/form-A';

// services
import contactUs from '../pages/services/contact-us';
import accountOfficer from '../pages/services/account-officer';
import lifestyle from '../pages/services/lifestyle';
import accountUpdate from '../pages/services/account-update';
import atmBranchLocator from '../pages/services/atm-branch-locator';
import complaints from '../pages/services/complaints';
import deleteProfile from '../pages/services/delete-profile';
import profile from '../pages/services/profile';
// account
import fundAccount from '../pages/account/fund-account';

// budget
import budgetManagement from '../pages/budget/budget-management';
import createBudget from '../pages/budget/create-budget';

// save as you spend 
import saveAsYouSpend from '../pages/save-as-you-spend/index';
import saveAsYouSpendDetail from '../pages/save-as-you-spend/_id/edit';
import createSaveAsYouSpend from '../pages/save-as-you-spend/create';

// lifestyle
import flightIndex from '../pages/lifestyle/flight/index';
import flightSearch from '../pages/lifestyle/flight/search';
import flightView from '../pages/lifestyle/flight/view';

import hotelIndex from '../pages/lifestyle/hotel/index';
import hotelSearch from '../pages/lifestyle/hotel/search';
import hotels from '../pages/lifestyle/hotel/hotels';
import hotelView from '../pages/lifestyle/hotel/view';



/* Error Pages */
import Error400 from '../errors/error_400';
import Error401 from '../errors/error_401';
import Error403 from '../errors/error_403';
import Error404 from '../errors/error_404';
import Error500 from '../errors/error_500';
import Error503 from '../errors/error_503';

// component
Vue.use(Router);

const routes = [
{ path: '', redirect: { name: 'default' } },
{
  path: '/dashboard',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'default',
    name: 'default',
    component: Default,
    meta: {
      title: 'TAJBank | Retail Banking',
    }
  },
  {
    path: 'transaction-history',
    name: 'transaction-history',
    component: transactionHistory,
    meta: {
      title: 'Transaction History | TAJBank - Retail Banking',
    }
  },
  {
    path: 'beneficiary-management',
    name: 'beneficiary-management',
    component: beneficiaryManagement,
    meta: {
      title: 'Beneficiary Management | TAJBank - Retail Banking',
    }
  },
  ]
},
{
  path: '/auth',
  component: Auth,
  meta: {
    requiresGuest: true
  },
  children: [
  {
    path: 'login',
    name: 'Login',
    component: login,
    meta: {
      title: ' login | TAJBank - Retail Banking',
    }
  },
  {
    path: 'forgot-password',
    name: 'forgot-password',
    component: forgotPassword,
    meta: {
      title: ' Forgot Password | TAJBank - Retail Banking',
    }
  },
  {
    path: 'register',
    name: 'register 1',
    component: Register,
    meta: {
      title: ' Register | TAJBank - Retail Banking',
    }
  }
  ]
},

// transactions transfer
{
  path: '/transfers',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'interbank-transfer',
    name: 'interbank-transfer',
    component: interbankTransfer,
    meta: {
      title: 'Interbank Transfer | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'own-account-transfer',
    name: 'own-account-transfer',
    component: ownAccountTransfer,
    meta: {
      title: 'Own Account Transfer | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'local-transfer',
    name: 'local-transfer',
    component: localTransfer,
    meta: {
      title: 'TAJ Account Transfer | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'multiple-transfer',
    name: 'multiple-transfer',
    component: multipleTransfer,
    meta: {
      title: 'Multiple Transfer | TAJBank -  Retail Banking',
    }
  },
  ]
},
// auth settings
{
  path: '/settings',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'change-pin',
    name: 'change-pin',
    component: changePin,
    meta: {
      title: 'Change Pin | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'change-security-question',
    name: 'change-security-question',
    component: changeSecurityQuestion,
    meta: {
      title: 'Change Security Question | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'change-password',
    name: 'change-password',
    component: changePassword,
    meta: {
      title: 'Change Password | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'reset-security-question',
    name: 'reset-security-question',
    component: resetSecurityQuestion,
    meta: {
      title: 'Reset Security Question | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'reset-pin',
    name: 'reset-pin',
    component: resetPin,
    meta: {
      title: 'Reset Pin | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'create-pin',
    name: 'create-pin',
    component: createPin,
    meta: {
      title: 'Create Pin | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'account-upgrade',
    name: 'account-upgrade',
    component: accountUpgrade,
    meta: {
      title: 'Account Upgrade | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'limit-upgrade',
    name: 'limit-upgrade',
    component: limitUpgrade,
    meta: {
      title: 'Limit Upgrade | TAJBank -  Retail Banking',
    }
  },
  ]
},
// Bills
{
  path: '/bills',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'airtime-purchase',
    name: 'airtime-purchase',
    component: airtimePurchase,
    meta: {
      title: 'Airtime Purchase | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'data-purchase',
    name: 'data-purchase',
    component: dataPurchase,
    meta: {
      title: 'Data Purchase | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'electricity-payment',
    name: 'electricity-payment',
    component: electricityPayment,
    meta: {
      title: 'Electricity Payment | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'cablePayment',
    name: 'cable-payment',
    component: cablePayment,
    meta: {
      title: 'Cable TV Payment | TAJBank -  Retail Banking',
    }
  },
  ]
},
// standing order 
{
  path: '/standingOrder',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'manage-standing-orders',
    name: 'manage-standing-orders',
    component: manageStandingOrder,
    meta: {
      title: 'Manage Standing Orders | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'local',
    name: 'local',
    component: standingOrderTaj,
    meta: {
      title: 'Standing Orders To TajBank | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'interbank',
    name: 'interbank',
    component: standingOrderOthers,
    meta: {
      title: 'Standing Orders To other banks | TAJBank -  Retail Banking',
    }
  },
  ]
},
// request Management
{
  path: '/requestManagement',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'card',
    name: 'card',
    component: cardRequest,
    meta: {
      title: 'Card Request | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'cheque',
    name: 'cheque',
    component: chequeRequest,
    meta: {
      title: 'Cheque Request | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'hotlist-card',
    name: 'hotlist-card',
    component: hotListCard,
    meta: {
      title: 'Hotlist Card | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'form-A',
    name: 'form A',
    component: formA,
    meta: {
      title: 'Form A | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'token',
    name: 'token',
    component: tokenRequest,
    meta: {
      title: 'Token Request | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'stop-cheque',
    name: 'stop-cheque',
    component: stopCheque,
    meta: {
      title: 'Stop Cheque | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'cash-withdrawal',
    name: 'cash-withdrawal',
    component: cashWithdrawal,
    meta: {
      title: 'Cash Withdrawal | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'statement-request',
    name: 'statement-request',
    component: statementRequest,
    meta: {
      title: 'Statement Request | TAJBank -  Retail Banking',
    }
  },
  ]
},

// services
{
  path: '/services',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'contact-us',
    name: 'contact-us',
    component: contactUs,
    meta: {
      title: 'Contact us | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'account-officer',
    name: 'account-officer',
    component: accountOfficer,
    meta: {
      title: 'Account Officer | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'lifestyle',
    name: 'lifestyle',
    component: lifestyle,
    meta: {
      title: 'Lifestyle | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'account-update',
    name: 'account-update',
    component: accountUpdate,
    meta: {
      title: 'Account Update | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'atm-branch-locator',
    name: 'atm-branch-locator',
    component: atmBranchLocator,
    meta: {
      title: 'ATM Branch Locator | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'complaints',
    name: 'complaints',
    component: complaints,
    meta: {
      title: 'Complaints Management| TAJBank -  Retail Banking',
    }
  },
  {
    path: 'delete-profile',
    name: 'delete-profile',
    component: deleteProfile,
    meta: {
      title: 'Delete Profile| TAJBank -  Retail Banking',
    }
  },
  {
    path: 'profile',
    name: 'profile',
    component: profile,
    meta: {
      title: 'Profile| TAJBank -  Retail Banking',
    }
  }
  ]
},
{
  path: '/save-as-you-spend',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'index',
    name: 'save-as-you-spend',
    component: saveAsYouSpend,
    meta: {
      title: 'Save As You Spend | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'edit',
    name: 'edit-save-as-you-spend',
    component: saveAsYouSpendDetail,
    meta: {
      title: 'Save As You Spend | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'create',
    name: 'create-save-as-you-spend',
    component: createSaveAsYouSpend,
    meta: {
      title: 'Create Save As You Spend | TAJBank -  Retail Banking',
    }
  }
]
},
// account 
{
  path: '/account',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'fund-account',
    name: 'fund-account',
    component: fundAccount,
    meta: {
      title: 'Fund Account | TAJBank -  Retail Banking',
    }
  },
  ]
},
// budget
{
  path: '/budget',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: 'budget-management',
    name: 'budget-management',
    component: budgetManagement,
    meta: {
      title: 'Budget Management | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'create-budget',
    name: 'create-budget',
    component: createBudget,
    meta: {
      title: 'Create Budget | TAJBank -  Retail Banking',
    }
  },
  ]
},
// lifestyle flight
{
  path: '/lifestyle/flight',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: '/',
    name: 'flight',
    component: flightIndex,
    meta: {
      title: 'Lifestyle - Flight | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'search',
    name: 'flight-search',
    component: flightSearch,
    meta: {
      title: 'Lifestyle - Flight | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'view/:id',
    name: 'flight-view',
    component: flightView,
    meta: {
      title: 'Lifestyle - Flight | TAJBank -  Retail Banking',
    }
  },
  ]
},
{
  path: '/lifestyle/hotel',
  component: Body,
  meta: {
    requiresAuth: true
  },
  children: [
  {
    path: '/',
    name: 'hotel',
    component: hotelIndex,
    meta: {
      title: 'Lifestyle - Hotel | TAJBank -  Retail Banking',
    }
  },
  {
    path: ':destination',
    name: 'hotel-search',
    component: hotelSearch,
    meta: {
      title: 'Lifestyle - Hotel | TAJBank -  Retail Banking',
    }
  },
  {
    path: ':id',
    name: 'hotels',
    component: hotels,
    meta: {
      title: 'Lifestyle - Hotel | TAJBank -  Retail Banking',
    }
  },
  {
    path: 'hotels/:id',
    name: 'hotel-view',
    component: hotelView,
    meta: {
      title: 'Lifestyle - Hotel | TAJBank -  Retail Banking',
    }
  },
  ]
},
// error pages
{
  path:'/error-400',
  name:'Error400',
  component:Error400,
  meta: {
      title: 'Error400 | TAJBank -  Retail Banking',
    }
},
{
  path:'/error-401',
  name:'Error401',
  component:Error401,
  meta: {
      title: 'Error401 | TAJBank -  Retail Banking',
    }
},
{
  path:'/error-403',
  name:'Error403',
  component:Error403,
  meta: {
      title: 'Error403 | TAJBank -  Retail Banking',
    }
},
{
  path:'/error-404',
  name:'Error404',
  component:Error404,
  meta: {
      title: 'Error404 | TAJBank -  Retail Banking',
    }
},
{
  path:'/error-500',
  name:'Error500',
  component:Error500,
  meta: {
      title: 'Error500 | TAJBank -  Retail Banking',
    }
},
{
  path:'/error-503',
  name:'Error503',
  component:Error503,
  meta: {
      title: 'Error503 | TAJBank -  Retail Banking',
    }
},
{
  path: '*',
  redirect: { name: 'default' }
}
];

const router = new Router({
  routes,
  base: process.env.BASE_URL,
  mode: 'hash',
  linkActiveClass: 'active',
  scrollBehavior () {
    return { x: 0, y: 0 };
  }
});
export default router;
